<template>
  <div class="supplier-wrapper">
    <div class="section">
      <div class="sectionInternal">
        <dl>
          <dt>
            <img src="../assets/icon21.png" alt="电商仓配">
          </dt>
          <dd>电商仓配</dd>
        </dl>
        <div class="synopsis">
          <div class="sectionTop">
            <p>业务介绍</p>
            <div></div>
          </div>
          <div class="account">
            <p title="电商仓配"><span>电商仓配</span>为电商提供一站式仓储配送服务以及保税业务</p>
            <ol class="list">
              <li>国内电商：将货物托管在我们仓库-通过系统同步电商订单-帮助打包-交给第三方物流（京东/邮政等）</li>
              <li>保税进口（1210）主要为跨境电商平台提供从国外运输，国内保税区备货，保税仓储、并在订单产生时直接从保税仓通关、分拣包装并发货的一体化服务。</li>
              <li>保税出口（9610）备案、报关数据-分拣打包-清单 申报-货物入仓、海关上线、抽检、清单放行、国际运输（E邮宝/邮政小包/专线）、退税</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="synopsisType">
        <div class="types">
          <div class="synopsisAll">
            <p @click="tabInternal" :class="internal?'active':''">国内电商</p>
            <p @click="tabBonded" :class="bonded?'active':''">保税出口</p>
            <p @click="tabEntrance" :class="entrance?'active':''">保税进口</p>
          </div>
          <div class="synopsisBox">
            <div class="domestic" v-if="internal">
              <img src="../assets/img1.png" alt="">
              <p>国内电商</p>
              <p>货物托管</p>
              <p>顾客下单</p>
              <p>交由第三方物流发货（京东、邮政等）</p>
            </div>
            <div class="declare" v-if="bonded">
              <div class="declareLeft">
                <div>
                  <div class="tit" title="保税出口服务介绍">保税出口服务介绍</div>
                  <p>电商企业将批量采购的货物，以临时入库单的形式报入电商保税账册，暂存保税仓。电商在得到消费者订单后，将订单发运指令发送给区内仓库，区内仓库根据订单打包，通过电商保税系统向电子底账申报入库以及出库，将包裹通过跨境通道交至给国际快递公司，然后由其投递至订单消费者。即，实际产生订单的货物才会实际报入保税仓库，未产生订单的货物仍然处于暂存状态，可以随时办理出库。这种模式适合于批量向供应商提前拿货的电商企业。</p>
                  <p>B2C出口业务，通过“清单核放、汇总申报”的方式，解决了电商企业原有以邮件快件出境无法办理退税的问题。</p>
                </div>
                <div>
                  <div class="tit">保税出口服务对象</div>
                  <p>中国境内注册的，有出口业务需求的电商企业、境内垂直行业电商平台、跨境电商海淘平台、全球品牌制造商。</p>
                </div>
              </div>
              <div class="declareRight">
                <div class="tit">保税出口服务流程</div>
                <img src="../assets/img.png" alt="">
              </div>
            </div>
            <div class="declare" v-if="entrance">
              <div class="declareLeft">
                <div>
                  <div class="tit">保税进口服务介绍</div>
                  <p>主要为跨境电商平台提供从国外运输，国内保税区备货，保税仓储、并在订单产生时直接从保税仓通关、分拣包装并发货的一体化服务。</p>
                  <p>保税进口服务按照“整批进、分散出”的形式进行；“整批进” 就是整批进口货物通过海外通综合服务平台向海关备案并申报进入海关保税区；“分散出”就是跨境电商将个人网购后产生的订单传送至跨境电商综合服务平台，平台立即向海关申报，实现自动化电子清关，清关成功后将根据订单分批运出保税仓并安排派送</p>
                </div>
                <div>
                  <div class="tit">保税进口服务对象</div>
                  <p>有进口保税仓储需求的境内垂直行业电商平台、跨境电商海淘平台、海外电商产品供应商。</p>
                </div>
              </div>
              <div class="declareRight">
                <div class="tit">保税进口服务流程</div>
                <div class="declareImg">
                  <img src="../assets/img2.png" alt="">
                  <p>备案、报关数据</p>
                  <p>分拣打包</p>
                  <p>清单申报</p>
                  <p>货物入仓、海关上线</p>
                  <p>抽检</p>
                  <p>清单放行</p>
                  <p>国际运输</p>
                  <p>退税</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spot">
      <div class="sectionTop">
        <p>速派电商仓配业务优势</p>
      </div>
      <div class="spotCont">
        <dl>
          <dt>
            <img src="../assets/icon8.png" alt="">
          </dt>
          <dd>
            <p>收费合理</p>
            <p>按单收取费用 无其他费用</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon9.png" alt="">
          </dt>
          <dd>
            <p>易用的行业系统</p>
            <p>严谨的研发团队</p>
            <p>提供高效的软件服务</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon10.png" alt="">
          </dt>
          <dd>
            <p>超低的入驻门槛</p>
            <p>不限制电商企业注册地与平台各类型平台均可对接</p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../assets/icon7.png" alt="">
          </dt>
          <dd>
            <p>一站式备案</p>
            <p>帮助海外客户 从成立公司申请证件和海关备案</p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Supplier',
  props:{

  },
  components:{

  },
  data(){
    return {
      internal:true,
      bonded:false,
      entrance:false
    }
  },
  computed:{

  },
  methods:{
    tabInternal(){
      this.internal = true;
      this.bonded = false;
      this.entrance = false;
    },
    tabBonded(){
      this.internal = false;
      this.bonded = true;
      this.entrance = false;
    },
    tabEntrance(){
      this.internal = false;
      this.bonded = false;
      this.entrance = true;
    }
  },
  created(){

  },
  mounted(){

  }
}
</script>
<style scoped lang="scss">
.supplier-wrapper {
  margin: 30px 0;
}
.section {
  min-height: 350px;
  .sectionInternal {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    dl {
      padding: 0 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 80px;
      min-height: 400px;
      width: 300px;
      dt {
        width: 160px;
        height: 130px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
          color: darkkhaki;
        }
      }
      dd {
        font-size: 23px;
        color: rgb(36,35,35);
        font-weight: bolder;
      }
    }
    .synopsis{
      width: 560px;
      .sectionTop {
        align-items: flex-start;
      }
      .account {
        color: rgb(117,115,115);
        p {
          span {
            color: $bg-color;
            font-size: 25px;
            margin-right: 20px;
          }
        }
        .list {
          width: 100%;
          margin-top: 30px;
          li {
            list-style-position: inside;
            text-indent: 17px;
            word-break: break-all;
            margin: 3px 0;
            line-height: 30px;
          }
        }
      }
    }
  }
  .synopsisType {
    width: 100%;
    margin: 30px 0;
    background: #f5f5f5;
    .types {
      width: 1000px;
      margin: 0 auto;
      .synopsisAll {
        display: flex;
        height: 60px;
        margin-bottom: 30px;
        p {
          margin: 0 10px;
          flex:1;
          text-align: center;
          line-height: 60px;
          font-size: 30px;
          box-shadow: 0 3px 3px 0 #ccc;
          color: #757373;
          background: #fff;
          cursor: pointer;
        }
        p.active {
          background: $bg-color;
          color: #fff;
        }
      }
      .synopsisBox {
        width: 100%;
        height: 100%;
        .domestic {
          width: 100%;
          min-height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          img {
            width: 600px;
            height: 100px;
          }
          p {
            font-size: 10px;
            position: absolute;
            top: 45%;
            left: 13%;
          }
          p:nth-child(3) {
            top: 0;
            left: 23%;
            color: $bg-color;
          }
          p:nth-child(4) {
            top: 0;
            left: 43%;
          }
          p:nth-child(5) {
            top: 42%;
            left: 80%;
            width: 120px;
            word-break: break-all;
            text-align: center;
          }
        }
        .declare {
          height: 100%;
          display: flex;
          .declareLeft {
            min-height: 350px;
            width: 400px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 10px;
            box-sizing: border-box;
            div {
              p {
                font-size: 14px;
                color: #515151;
                line-height: 35px;
                text-indent: 35px;
              }
              .tit {
                margin-bottom: 20px;
                font-size: 18px;
                color: #515151;
                background: #EFEFEF;
                line-height: 36px;
                width: 170px;
                text-align: center;
              }
            }
          }
          .declareRight {
            display: flex;
            flex-direction: column;
            .tit {
              margin-bottom: 40px;
              font-size: 18px;
              color: #515151;
              background: #EFEFEF;
              line-height: 36px;
              width: 168px;
              text-align: center;
            }
            img {
              width: 600px;
            }
            .declareImg {
              flex: 1;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              p {
                position: absolute;
                bottom: 20%;
                left: 0;
                font-size: 10px;
              }
              p:nth-child(3) {
                top: 20%;
                left: 15%;
              }
              p:nth-child(4) {
                bottom: 20%;
                left: 27%;
              }
              p:nth-child(5) {
                top: 20%;
                left: 34%;
              }
              p:nth-child(6) {
                bottom: 20%;
                left: 53%;
              }
              p:nth-child(7) {
                top: 20%;
                left: 63%;
              }
              p:nth-child(8) {
                bottom: 20%;
                left: 75%;
              }
              p:nth-child(9) {
                top: 20%;
                left: 89%;
              }
            }
          }
        }
      }
    }
  }
}
.spot {
  width: 1000px;
  margin: 0 auto;
  .spotCont {
    display: flex;
    margin-top: 30px;
    justify-content: space-around;
    dl {
      width: 150px;
      min-height: 150px;
      margin: 0 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      dt {
        height: 90px;
      }
      dd {
        width: 100%;
        flex: 1;
        p {
          width: 100%;
          text-align: center;
          font-size: 17px;
          line-height: 30px;
          word-break: break-all;
        }
        p:not(:first-child) {
          font-size: 13px;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Supplier.vue